import { Attributes, List, LookupBase } from '@singularsystems/neo-core';
import ParticipantIncentiveSchemeTypeTaxRateLookup from './ParticipantIncentiveSchemeTypeTaxRateLookup';

export default class PortfolioSettingsLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    @Attributes.Float()
    @Attributes.Nullable()
    public taxPercentage: number | null = 0;

    public showParticipantBrokerDetailsPage: boolean = true;

    public includeBrokerageInTaxDirective: boolean = false;

    public allowTradeCancellation: boolean = false;

    public settlementRequiresTaxDirective: boolean = false;

    public baseCurrencyId: number = 0;

    public showParticipantTradeDetailsButton: boolean = false;

    public readonly showParticipantPortfolioSummary: boolean | null = null;

    public readonly showGrossValueAtAwardDate: boolean | null = null;

    public readonly portfolioDetailsFilterByCalendarYear: boolean = false;

    public brokerDetailsRequiredOnTradeEntry: boolean = false;

    public participantIncentiveSchemeTypeTaxRates = new List(ParticipantIncentiveSchemeTypeTaxRateLookup);

    public secondmentConfirmation: boolean = false;

    public readonly allowSecondmentPaymentCountrySelection: boolean = true;

    public residentCountryId: number = 0;

    public residentCountryName: string = "";

    public readonly requireBrokerContactDetails: boolean = false;

    public allowParticipantPortfolioDownload: boolean = false;

    public readonly showDetailedStatusesOnTradeHistory: boolean = false;
    
    public readonly isMSRParticipant: boolean = false;

    public readonly allowParticipantCompletedTradesDownload: boolean = false;


    // Client only properties / methods

    public missingTaxRate: boolean = false;

    public get taxPercentageOrDefault() {
        return this.taxPercentage ?? 0;
    }
}